import { useEffect, useState } from "react";
import { Receipt } from "@phosphor-icons/react";
import { api } from "@/lib/api";

const money = (n) =>
  `$${Number(n || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

const BADGE = {
  Sent: "border-yellow-500/40 text-yellow-300",
  "Partly paid": "border-blue-500/40 text-blue-300",
  Overdue: "border-red-500/40 text-red-300",
  Draft: "border-zinc-700 text-zinc-400",
};

export default function MobileBills() {
  const [rows, setRows] = useState([]);
  const [outstanding, setOutstanding] = useState(0);

  useEffect(() => {
    api
      .get("/invoices")
      .then(({ data }) => {
        const open = (data.invoices || []).filter(
          (r) => r.collect_payment && r.status !== "Paid" && r.status !== "Void" && r.balance > 0.01,
        );
        open.sort((a, b) => b.balance - a.balance);
        setRows(open);
        setOutstanding(open.reduce((n, r) => n + r.balance, 0));
      })
      .catch(() => {});
  }, []);

  return (
    <div className="px-4 pt-4" data-testid="mobile-bills">
      <h1 className="m-title m-display text-3xl text-[#c39e6d]">Bills</h1>
      <p className="mt-1.5 text-[11px] font-bold uppercase tracking-[0.18em] text-zinc-500">
        Outstanding {money(outstanding)} · {rows.length} open
      </p>

      <div className="mt-4 space-y-3">
        {rows.length === 0 && (
          <div
            data-testid="mobile-bills-empty"
            className="rounded-2xl border border-dashed border-zinc-800 p-8 text-center text-sm text-zinc-500"
          >
            No outstanding bills.
          </div>
        )}
        {rows.map((r) => (
          <div
            key={r.id}
            data-testid={`mobile-bill-${r.id}`}
            className="rounded-2xl border border-zinc-800 bg-[#0F172A] p-4"
          >
            <div className="flex items-center gap-2">
              <span className="font-mono-data text-xs text-yellow-500">
                {r.code}
              </span>
              {r.kind === "deposit" && (
                <span className="rounded-full border border-[#c39e6d]/40 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-widest text-[#c39e6d]">
                  Deposit
                </span>
              )}
              <span
                className={`ml-auto rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-widest ${
                  BADGE[r.status] || "border-zinc-700 text-zinc-400"
                }`}
              >
                {r.status}
              </span>
            </div>
            <div className="mt-2 text-sm font-bold text-zinc-100">
              {r.customer_name || "—"}
            </div>
            {r.title && <div className="text-xs text-zinc-500">{r.title}</div>}
            {r.job_address && (
              <div className="mt-1 text-xs text-zinc-500">{r.job_address}</div>
            )}
            <div className="mt-3 flex items-center justify-between border-t border-zinc-800 pt-3 text-sm">
              <span className="text-zinc-500">Amount due</span>
              <span className="font-bold text-zinc-100">
                {money(r.balance)}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
